import { render, staticRenderFns } from "./CustomerTypeSection.vue?vue&type=template&id=45a68203&scoped=true"
import script from "./CustomerTypeSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerTypeSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomerTypeSection.vue?vue&type=style&index=0&id=45a68203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a68203",
  null
  
)

export default component.exports